import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const VerifyEmail = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "verify-email" */ './hocs')),
});
